import decode from "jwt-decode";
export default class AuthService {
  constructor(domain) {
    this.domain = domain || process.env.REACT_APP_API_URL;
    this.fetch = this.fetch.bind(this);
    this.login = this.login.bind(this);
    this.getProfile = this.getProfile.bind(this);

    this.download = this.download.bind(this);
    this.get = this.get.bind(this);
    this.post = this.post.bind(this);
    this.put = this.put.bind(this);
    this.delete = this.delete.bind(this);
    this.atualizarEmpresaProfile = this.atualizarEmpresaProfile.bind(this);
  }

  login(username, password) {
    this.logout();
    return this.fetch(`${this.domain}/login`, {
      method: "POST",
      body: JSON.stringify({
        username,
        password,
      }),
    }).then((res) => {
      var response = this.verificaBloqueio(res.empresa.dataBloqueio, res);

      if (response.id) {
        this.setProfile(res);
        this.setToken(res.token);
      }
      return Promise.resolve(response);
    });
  }

  verificaBloqueio(dataBloqueio, usuario) {
    if (dataBloqueio) {
      let hoje = new Date();
      dataBloqueio = new Date(dataBloqueio);
      if (!usuario.admin) {
        if (
          hoje.getTime() > dataBloqueio.getTime() &&
          (usuario.empresa.tipoConta === "TEMPORARIA" ||
            usuario.empresa.tipoConta === "TEMPORARIA_EXTENDED")
        ) {
          return {
            text: "BLOCK_EMPRESA_TEMPORARIA",
            tipo: usuario.empresa.tipoConta,
          };
        } else if (hoje.getTime() > dataBloqueio.getTime()) {
          return { text: "BLOCK_EMPRESA" };
        } else {
          return usuario;
        }
      } else {
        return usuario;
      }
    } else {
      return usuario;
    }
  }

  isAdmin() {
    const usuario = this.getProfile();
    if (usuario.admin) {
      return true;
    } else {
      return false;
    }
  }

  loggedIn() {
    const token = this.getToken();
    return !!token && !this.isTokenExpired(token);
  }

  isTokenExpired(token) {
    try {
      const decoded = decode(token);
      if (decoded.exp < Date.now() / 1000) {
        return true;
      } else return false;
    } catch (err) {
      return false;
    }
  }

  setToken(idToken) {
    localStorage.setItem("id_token", idToken);
  }

  getToken() {
    // Recupera o token do usuário do localStorage
    return localStorage.getItem("id_token");
  }

  logout() {
    localStorage.removeItem("_profile");
    localStorage.removeItem("id_token");
  }

  getProfile() {
    let profileString = localStorage.getItem("_profile");
    return JSON.parse(profileString);
  }

  setProfile(profile) {
    localStorage.setItem("_profile", JSON.stringify(profile));
  }

  atualizarEmpresaProfile(empresa) {
    let profile = this.getProfile();
    profile.empresa = empresa;
    localStorage.setItem("_profile", JSON.stringify(profile));
  }

  fetch(url, options) {
    const token = this.getToken();

    if (!options) {
      options = {};
    }
    options.headers = {
      //"Authorization": "Bearer " + (token!== null ? token : ''),
      Accept: "application/json",
      "Content-Type": "application/json; charset=utf-8",
    };
    if (token) {
      options.headers["Authorization"] = "Bearer " + token;
    }

    return fetch(url, options)
      .then(this._checkStatus)
      .then((response) => response.json());
  }

  download(url, options) {
    const token = this.getToken();

    if (!options) {
      options = {};
    }
    options.headers = {
      Authorization: "Bearer " + (token !== null ? token : ""),
      "Content-Type": "application/octet-stream",
    };
    return fetch(this.domain + url, options)
      .then(this._checkStatus)
      .then((response) => response.blob());
  }

  post(url, obj) {
    return fetch(this.domain + url, {
      method: "POST",
      body: JSON.stringify(obj),
      headers: {
        Authorization: "Bearer " + this.getToken(),
        Accept: "application/json",
        "Content-Type": "application/json; charset=utf-8",
      },
    })
      .then(this._checkStatus)
      .then((response) => response.json());
  }

  getNoToken(url) {
    return fetch(this.domain + url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json; charset=utf-8",
      },
    })
      .then(this._checkStatus)
      .then((response) => response.json());
  }
  get(url) {
    return fetch(this.domain + url, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + this.getToken(),
        Accept: "application/json",
        "Content-Type": "application/json; charset=utf-8",
      },
    })
      .then(this._checkStatus)
      .then((response) => response.json());
  }

  request(url, options) {
    options = {
      ...options,
      headers: {
        Authorization: "Bearer " + this.getToken(),
        Accept: "application/json",
        "Content-Type": "application/json; charset=utf-8",
      },
    };
    return fetch(this.domain + url, options).then(this._checkStatus);
  }

  myFetch(url, options) {
    return fetch(this.domain + url, options).then(this._checkStatus);
  }

  put(url, obj) {
    return fetch(this.domain + url, {
      method: "PUT",
      body: JSON.stringify(obj),
      headers: {
        Authorization: "Bearer " + this.getToken(),
        Accept: "application/json",
        "Content-Type": "application/json; charset=utf-8",
      },
    })
      .then(this._checkStatus)
      .then((response) => response.json());
  }

  delete(url, obj) {
    return fetch(this.domain + url, {
      method: "DELETE",
      body: JSON.stringify(obj),
      headers: {
        Authorization: "Bearer " + this.getToken(),
        Accept: "application/json",
        "Content-Type": "application/json; charset=utf-8",
      },
    })
      .then(this._checkStatus)
      .then((response) => response.json());
  }

  _checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
      return response;
    } else {
      var error = { message: response.statusText, response };
      throw error;
    }
  }
}
